import { render } from "./vadvertiserslist.vue?vue&type=template&id=55b3f21b&scoped=true"
import script from "./vadvertiserslist.vue?vue&type=script&lang=js"
export * from "./vadvertiserslist.vue?vue&type=script&lang=js"

import "./vadvertiserslist.vue?vue&type=style&index=0&id=55b3f21b&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b3f21b"]])

export default __exports__